export default "__VITE_ASSET__4303316c__"